import commonJobs from '@/store/common-modules/jobs';

export default {
  namespaced: true,
  modules: {
    commonJobs,
  },
  getters: {
  },
  actions: {
  },
};
